import request from '@/utils/request'

// 获取用户信息
export const getUserInfo = () => request({
  url: '/bd/user/userInfo',
  method: 'get'
})
// 修改用户信息
export const updateUserInfo = (data) => request({
  url: '/bd/user/updateUser',
  method: 'post',
  data,
  headers: { 'Content-Type': 'application/json' }
})
// 修改用户密码
export const updatePassword = (data) => request({
  url: '/bd/user/updatePassword',
  method: 'post',
  data,
  headers: { 'Content-Type': 'application/json' }
})
// 上传
export const upload = (data) => request({
  url: "/base/uploadWithName",
  method: 'post',
  data,
  headers: { 'Content-Type': 'multipart/form-data' }
})